<template>
    <Carousel class="banner-texts" v-model="bannerTextIndex" autoplay arrow="never" :dots="bannerTexts&&bannerTexts.length>1?'inside':'none'">
        <CarouselItem v-for="bannerTextItem in bannerTexts" :key="bannerTextItem.id">
            <a class="banner-link" @click.stop.prevent="$emit('bannerItemClicked',bannerTextItem.id)" href="javascript:void(0)">{{bannerTextItem.text}}</a>
        </CarouselItem>
    </Carousel>
</template>
<script>
    export default {
        props: {
            bannerTexts: {
                type: Array,
                required: true
            }
        },
        data: function() {
            return {
                bannerTextIndex: 0
            };
        }
    };
</script>
<style lang="postcss">
.banner-texts {
  background-color: #f93;
  cursor: pointer;
  &:hover {
    color: #3dc6b6;
    text-decoration: none;
  }
  .banner-link {
    display: block;
    color: white;
    font-size: 16px;
    line-height: 16px;
    padding: 15px 20px;
    &:hover {
      color: #3dc6b6;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// BannerTexts.vue?97dd9e62